import { render, staticRenderFns } from "./CaseIcon.vue?vue&type=template&id=2aa676dc"
import script from "./CaseIcon.vue?vue&type=script&lang=js"
export * from "./CaseIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports